import { render } from "./PaidContentComponent.vue?vue&type=template&id=f12a3a36"
import script from "./PaidContentComponent.vue?vue&type=script&lang=js"
export * from "./PaidContentComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ricpp/Development/boldbrush/blog_post_editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__